import { uploadFiles } from '../api/files';
import { deleteFiles } from '../api/files/deleteFiles';
import { updateFiles } from '../api/files/updateFiles';
import { prepareFormDataForUpdate, prepareFormDataForUpload } from '../api/helpers';
import { RParentFolder, StrapiUploadFileField, StrapiUploadFileRef } from '../types';
import { Administration, Association, Company, Institution } from '../types/Institution';
import { isFileToUpload, SortedMedia } from './uploads';

export function isCompany(institution: Institution): institution is Company {
    return institution.type === 'company';
}

export function isAssociation(institution: Institution): institution is Association {
    return institution.type === 'association';
}

export function isOrganisation(
    institution: Institution
): institution is Administration | Association {
    return institution.type === 'association' || institution.type === 'administration';
}

export async function updateInstitutionFiles(
    institutionId: number,
    sorted: SortedMedia,
    fieldType: StrapiUploadFileField
) {
    const { mediaToUpdate, mediaToUpload, mediaToDelete } = sorted;
    const strapiConfig = {
        parentId: institutionId.toString(),
        collectionRef: StrapiUploadFileRef.Institution,
        fieldType
    };

    // Upload new files
    const filesToUpload = mediaToUpload.filter(isFileToUpload);

    const data = prepareFormDataForUpload(filesToUpload, strapiConfig);

    if (data.length > 0)
        await uploadFiles(institutionId.toString(), RParentFolder.INSTITUTIONS, data);

    // Update changed files
    if (mediaToUpdate.length > 0)
        await updateFiles(
            mediaToUpdate.map((f) => ({
                id: f.id,
                data: prepareFormDataForUpdate(f, strapiConfig)
            }))
        );

    // Delete removed files
    if (mediaToDelete.length > 0) await deleteFiles(mediaToDelete.map((file) => file.id));
}
